import { SellerOrderItemUi } from '@/components/SellerOrders/Table/SellerOrdersUi';
import { SellerOrderResponse } from '@/data/api/model/sellerOrders/SellerOrdersDto';
import { getStatusBadge } from '@/hooks/order/useGetDetailOrders/mapper';
import { formatDollarAmount } from '@/utils/amounts';
import { formatDate, formatDayJsDate } from '@/utils/dateTime';
import dayjs from 'dayjs';

export const sellerOrderResponseToSellerOrderItem = (
  item: SellerOrderResponse
): SellerOrderItemUi => {
  let deliveryDateFormatted: string;
  if (item.delivery?.delivery_date) {
    const parsedDate = dayjs(item.delivery?.delivery_date, 'YYYY-MM-DD');
    deliveryDateFormatted = formatDayJsDate(parsedDate);
    deliveryDateFormatted +=
      item.delivery?.delivery_time && item.delivery.delivery_time_end
        ? ` (${item.delivery?.delivery_time}-${item.delivery?.delivery_time_end})`
        : '(Sin slot de entrega)';
  } else {
    deliveryDateFormatted = 'NA';
  }

  return {
    orderDetailId: item.order_detail_id,
    orderId: item.order_detail_number,
    buyer: item.business_name,
    createdAt: formatDate(item.created_at, { time: true }),
    deliveryDate: deliveryDateFormatted,
    badgeStatus: getStatusBadge(item.status),
    total: `${formatDollarAmount(item.total_order_detail_amount)}`,
  };
};
